import { readCookie } from "common/utils/cookie";
import { detectPageType } from "common/utils/detect-page-type/page-type";

/**
 * @function checkIsFirstTimeVisitor Check if the visitor is a first time visitor
 * @returns {boolean} True if the visitor is a first time visitor, false otherwise
 */
function checkIsFirstTimeVisitor() {
  const isFirstTimeVisitor = typeof readCookie("name") === "undefined";
  const pageType = detectPageType();
  const storageKey = "isFirstTimeVisitor";
  const isNotFirstTimeLocalStorage = localStorage.getItem(storageKey) === null;

  const isSpecialPages =
    pageType.isProductListingPage ||
    pageType.isProductDetailsPage ||
    pageType.isBrandPage ||
    pageType.isHomepage;

  if (isFirstTimeVisitor && isSpecialPages && isNotFirstTimeLocalStorage) {
    localStorage.setItem(storageKey, "true");
    return true;
  }

  return false;
}

/**
 * @function createGlobalFirstTimeVisitorChecker Create a global function that caches the result of checkIsFirstTimeVisitor
 * @description The bundler creates a new function for each file import
   and we need to cache the result to avoid multiple calls to checkIsFirstTimeVisitor
   we are storing function in the window object
 * @returns {function} A function that checks if the visitor is a first time visitor
 */
function createGlobalFirstTimeVisitorChecker() {
  if (!window.jiffyIsFirstTimeVisitor) {
    let cachedResult = null;
    let hasBeenCalled = false;

    window.jiffyIsFirstTimeVisitor = function checkIsFirstTimeVisitorGlobal() {
      if (hasBeenCalled) return cachedResult;

      hasBeenCalled = true;
      cachedResult = checkIsFirstTimeVisitor();

      return cachedResult;
    };
  }

  return window.jiffyIsFirstTimeVisitor;
}

export const isCheckIsFirstTimeVisitor = createGlobalFirstTimeVisitorChecker();

/**
 * @function removeElementAndNextScript Remove an element and its next script sibling
 * @param {Element|null} element - The marker element
 */
function removeElementAndNextScript(element) {
  if (!element) return;
  const nextScript = element.nextElementSibling;
  if (nextScript?.tagName === "SCRIPT") {
    nextScript.remove();
  }
  element.remove();
}

/**
 * @function removeTidioChatScript Remove the tidio chat script
 * @param {Document} context - The document object
 */
export function removeTidioChatScript(context = document) {
  const $tidioChatScript = context.getElementById("tidio-chat-script");
  const $tidioChatScriptPack = context.getElementById("tidio-chat-script-pack");
  const $trustedStoresScript = context.getElementById("trusted-stores-script");
  const $googleTopQualityStoreMarker = context.getElementById("google-top-quality-store-script");

  $tidioChatScript?.remove();
  removeElementAndNextScript($tidioChatScriptPack);
  $trustedStoresScript?.remove();
  removeElementAndNextScript($googleTopQualityStoreMarker);
}
